import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../app/store/userSlice';
import { stopMasquerade } from '../app/store/masqueradeSlice';
import type { RootState } from '../app/store';

export const useLogout = (): (() => Promise<void>) => {
  const { userId: masqueradeUserId } = useAppSelector(
    (state: RootState) => state.masquerade,
  );
  const dispatch = useAppDispatch();
  const { signOut } = useAuthenticator();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      if (masqueradeUserId) await dispatch(stopMasquerade() as any);
      await dispatch(logoutUser() as any);
      await signOut();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }, [dispatch, navigate, signOut, masqueradeUserId]);

  return handleLogout;
};

export default useLogout;
